// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-data-wrap[data-v-c8925c8a] {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.no-data-wrap .no-data[data-v-c8925c8a] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  font-size: 14px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.24);\n}\n.no-data-wrap .no-data img[data-v-c8925c8a] {\n  width: 200px;\n  height: 124px;\n}\n", ""]);
// Exports
module.exports = exports;
